module.exports = __webpack_public_path__ + "static/img/img-talk.e16fee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c28/img-talk.png
// module id = VrWi
// module chunks = 0